import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import PasswordGate from './auth/PasswordGate.jsx';
import HomePage from './pages/HomePage.jsx';
import CreatePage from './pages/CreatePage.jsx';
import DraftPage from './pages/DraftPage.jsx';
import GeneratingPage from './pages/GeneratingPage.jsx';
import ReaderPage from './pages/ReaderPage.jsx';
import AdminPage from './pages/AdminPage.jsx';

export default function App() {
  useEffect(() => {
    const evtSource = new EventSource('/api/auth/stream');
    evtSource.onmessage = (event) => {
      if (event.data === 'reload') {
        window.location.reload();
      }
    };
    return () => evtSource.close();
  }, []);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/story/:slug" element={<ReaderPage />} />

        <Route
          path="/create"
          element={
            <PasswordGate>
              <CreatePage />
            </PasswordGate>
          }
        />
        <Route
          path="/draft/:storyId"
          element={
            <PasswordGate>
              <DraftPage />
            </PasswordGate>
          }
        />
        <Route
          path="/generating/:jobId"
          element={
            <PasswordGate>
              <GeneratingPage />
            </PasswordGate>
          }
        />

        <Route
          path="/admin"
          element={
            <PasswordGate role="admin">
              <AdminPage />
            </PasswordGate>
          }
        />

        <Route path="*" element={<HomePage />} />
      </Routes>
    </Layout>
  );
}
